import React from "react";
import "./Gift_Customisation.css";
import Heading_banner_section from "../../common_components/heading_banner/Heading_banner_section";
import Customisation_Form from "./customisation_form/Customisation_Form";
import Personalise_Gift_Swiper from "./personalise_gift_swiper/Personalise_Gift_Swiper";
import Your_Idea from "../../common_components/your_Idea/Your_Idea";
import How_costomization_works from "./how_costomization_works/How_costomization_works";

const Gift_Customisation = () => {
  return (
    <section className="Gift_Customisation">
      <Heading_banner_section
        headingText={"GIFT CUSTOMISATION"}
        subHeadingText={"Make your gift unique with a personal touch"}
      />
      {/* <Your_Idea btnText={"Customize Bespoke Gifts"}/> */}
      <How_costomization_works />
      {/* <div className="bottom_div">
        <Personalise_Gift_Swiper />
      </div> */}
      <div className="customisation_div">
        <Customisation_Form />
      </div>
    </section>
  );
};

export default Gift_Customisation;
